import { TicketRowItem } from "../TicketsTable/types";

export type WorkflowDetailsHeaderProps = {
  workflow: TicketRowItem;
  onClose: () => void;
};

export type WorkflowDetailsDrawerProps = {
  workflow: TicketRowItem | undefined;
  onClose: () => void;
};

export enum TabType {
  Tasks = "tasks",
  ClientCommunications = "client-communications",
  RequestDetails = "request-details",
}
